"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_1 = require("./styled");
var edit_1 = tslib_1.__importDefault(require("../icons/edit"));
var CircleButton = function (_a) {
    var className = _a.className, size = _a.size, icon = _a.icon, props = tslib_1.__rest(_a, ["className", "size", "icon"]);
    var iconSize = react_1.useMemo(function () { return size / 2; }, [size]);
    return (react_1.default.createElement(styled_1.Container, tslib_1.__assign({}, props, { size: size, className: "primary-bg " + className }), icon({ size: iconSize })));
};
CircleButton.defaultProps = {
    size: 32,
    icon: edit_1.default,
};
exports.default = CircleButton;
//# sourceMappingURL=index.js.map